import { grey } from '@material-ui/core/colors';
export var defaultGreen = '#4caf50';
export var defaultGreenDarker = '#448744';
export var defaultRed = '#e6433f';
export var defaultRedDarker = '#af423e';
export var defaultOrange = '#ff9d0d';
export var defaultOrangeDarker = '#cd6e0d';
export var defaultGrey = grey[700];
export var defaultGrey2 = '#787879';
export var defaultGreyLight = grey[500];
export var defaultGreyLight2 = grey[600];
export var defaultGreyLight3 = '#f7f7f7';
export var defaultGreyLight200 = grey[200];
export var defaultGreyDisabled = grey[400];
export var defaultGreyLight4 = '#f2f2f2';
export var defaultGreyLight5 = '#B2B2B2';
export var defaultGreyDark = '#817e7d';
export var defaultWhite = '#ffffff';
export var defaultBlack = '#000';
export var defaultBlue = '#003473';
export var defaultYellow = '#ffed00';
export var defaultBadgeColor = '#e31c1c';